import { makeStyles, createStyles, Theme } from '@material-ui/core/styles';
import sicrediStyles from 'assets/styles/default.scss';

export default makeStyles(
  (theme: Theme) =>
    createStyles({
      content: {
        paddingTop: theme.spacing(5),
      },
      leftSide: {
        display: 'flex',
        flexDirection: 'column',
      },
      title: {
        fontFamily: '"Exo 2", Sans-serif',
        fontStyle: 'normal',
        fontWeight: 300,
        fontSize: '32px',
        lineHeight: '162%',
        color: sicrediStyles.secondarySicrediDark,
        maxWidth: '566px',
        '@media (max-width: 1040px)': {
          maxWidth: '400px',
        },
        [theme.breakpoints.down('sm')]: {
          maxWidth: 'inherit',
        }
      },
      descriptionHighlight: {
        marginTop: theme.spacing(2),
        backgroundColor: sicrediStyles.primarySicrediLight,
        color: sicrediStyles.secondarySicrediDarker,
        padding: theme.spacing(2),
        fontFamily: 'Nunito',
        fontStyle: 'normal',
        fontWeight: 'bold',
        fontSize: '16px',
        lineHeight: '24px',
        maxWidth: '566px',
        borderRadius: '8px',
        '@media (max-width: 1040px)': {
          maxWidth: '400px',
        },
        [theme.breakpoints.down('sm')]: {
          maxWidth: 'inherit',
        }
      },
      description: {
        margin: theme.spacing(2, 0),
        maxWidth: '566px',
        '@media (max-width: 1040px)': {
          maxWidth: '400px',
        },
        [theme.breakpoints.down('sm')]: {
          maxWidth: 'inherit',
        }
      },
      rightTextContent: {
        position: 'relative',
        // minHeight: '315px',
        textAlign: 'center',
      },
      rightImage: {
        // position: 'absolute',
        // top: 0,
        // right: '210px',
        maxWidth: '496px',
        width: '100%',
        height: 'auto',
        // '@media (max-width: 1170px)': {
        //   top: `${(50 * 100 / 1170)}vw`,
        //   width: `${(496 * 100 / 1170)}vw`,
        //   right: `${(190 * 100 / 1170)}vw`,
        // },
        [theme.breakpoints.down('sm')]: {
          position: 'relative',
          top: 'inherit',
          right: 'inherit',
          width: '100%',
        }
      },
      rightText: {
        position: 'absolute',
        top: 0,
        right: 0,
        whiteSpace: 'pre',
        fontFamily: '"Exo 2", Sans-serif',
        fontStyle: 'normal',
        fontWeight: 'bold',
        fontSize: '32px',
        lineHeight: '125%',
        textAlign: 'right',
        color: sicrediStyles.primarySicrediDark,
        '@media (max-width: 1170px)': {
          fontSize: `${(32 * 100 / 1170)}vw`
        },
        [theme.breakpoints.down('sm')]: {
          position: 'relative',
          top: 'inherit',
          right: 'inherit',
          width: '100%',
          whiteSpace: 'inherit',
          fontSize: '32px',
          textAlign: 'center',
        },
        '&:after': {
          content: '""',
          display: 'block',
          width: '46px',
          height: '3px',
          backgroundColor: sicrediStyles.primarySicrediDark,
          position: 'absolute',
          right: 0,
          bottom: '-20px',
          [theme.breakpoints.down('sm')]: {
            content: 'none',
          }
        }
      },
      largeAssembleiasHeader: {
        marginTop: theme.spacing(3)
      },
      assembleiasTitle: {
        fontFamily: 'Exo 2',
        fontStyle: 'normal',
        fontWeight: 600,
        fontSize: '20px',
        lineHeight: '24px',
        color: sicrediStyles.secondarySicrediDarker,
      },
      assembleiasSubtitle: {
        fontFamily: 'Exo 2',
        fontStyle: 'normal',
        fontWeight: 300,
        fontSize: '12px',
        lineHeight: '24px',
        color: sicrediStyles.secondarySicrediDarker,
      },
      chevronIcon: {
        transform: 'rotate(0deg)',
        transition: 'transform 0.3s ease-out',
      },
      openedChevronIcon: {
        transform: 'rotate(180deg)',
      },
      demaisAssembleiasWrapper: {
        marginTop: theme.spacing(2)
      }
    }),
  {
    name: 'TelaInicialAssociado',
  }
);